import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class UsuarioService extends CRUDService{
    constructor() {
        super("usuario");
    }

    me() {
        return http.get("/"+this.serviceName+"/me", {dontCancel: true})
    }

    filterByName(name) {
        return http.get("/"+this.serviceName+"/nome/" + encodeURIComponent(name))
    }

    getByLogin(login) {
        return http.get("/"+this.serviceName+"/" + encodeURIComponent(login))
    }

    checkLogado() {
        return http.get("/"+this.serviceName+"/isLogado")
    }

}